module.exports = __webpack_public_path__ + "img/sld_ch_2_t1_green.a49f7fee.svg";